// Retired <subdomain>.ea.asu.edu partner hosts -> the welcome site they now land on.
// hs (ACC-328): its partner lookup 404s into the "Oops" page, so HS goes to ULC.
// kupu, gems (ULC-3500): forwarded to organic EA until their DNS records are removed.
// Map, not an object literal, so inherited keys like `constructor` never match.
const RETIRED_EA_SUBDOMAINS = new Map([
  ['hs', 'ulc'],
  ['kupu', 'ea'],
  ['gems', 'ea']
]);

/**
 * True when a partner's URL subdomain points at a retired host. The traffic cop
 * must not send those learners back to it, or they bounce off the router redirect.
 */
export function isRetiredEaSubdomain(subdomain) {
  return typeof subdomain === 'string' && RETIRED_EA_SUBDOMAINS.has(subdomain.toLowerCase());
}

/**
 * Maps a retired <subdomain>[-env].ea.asu.edu host to welcome[-env].<ulc|ea>.asu.edu,
 * keeping path, query and hash. Exact subdomain match so hs4cc and other
 * prefixed partners are untouched.
 * @returns {string|null} redirect URL, or null when the host isn't retired
 */
export function getRetiredHostRedirectUrl({ protocol, hostname, port, pathname, search, hash }) {
  const [subdomain, ...rest] = hostname.split('.');
  const match = /^([a-z0-9]+)(-[a-z]+)?$/i.exec(subdomain);
  if (!match || rest.join('.') !== 'ea.asu.edu') return null;

  const target = RETIRED_EA_SUBDOMAINS.get(match[1].toLowerCase());
  if (!target) return null;

  const host = [`welcome${match[2] || ''}`, target, ...rest.slice(1)].join('.');
  return `${protocol}//${host}${port ? `:${port}` : ''}${pathname}${search}${hash}`;
}
